// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://54.213.251.72:3000/api/',
  // imageURL: 'http://54.213.251.72:3000/api/'
  // apiUrl: 'http://192.168.1.200:3000/api/',
  // imageURL: 'http://192.168.1.200:3000/api/'

  // apiUrl: 'http://192.168.1.200:3000/api/',
  // imageURL: 'http://192.168.1.200:3000/api/'

  // apiUrl: 'http://35.94.251.207:3000/api/',
  //imageURL: 'http://35.94.251.207:3000/api/'

 // apiUrl: 'http://35.94.251.207:3000/api/',
//imageURL: 'http://35.94.251.207:3000/api/',

  // apiUrl: 'http://192.168.0.40:3000/api/',
  // imageURL: 'http://192.168.0.40:3000/api/'
  // apiUrl: 'http://35.88.182.193:3000/api/',
  //  imageURL: 'http://35.88.182.193:3000/api/'
//  apiUrl: 'http://localhost:3000/api/',
 //  imageURL: 'http://localhost:3000/api/'
  // apiUrl: 'http://localhost:3000

    apiUrl: 'https://thenccos.com/api/',
   imageURL: 'https://thenccos.com/api/'
};
